var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 60373",
    xmlns: "http://www.w3.org/2000/svg",
    width: 363.105,
    height: 363.106,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 58947",
    fill: "none",
    d: "M0 0h363.106v363.106H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 60372",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 132890",
    d: "M242.856 120.8h-32.807q8.9 10.811 11.26 26.428h27.941l-6.394 20.955h-21.13q-2.5 23.692-19.6 35.67t-47.542 11.978l68.532 76.738v1.61h-31.555l-73.675-82.725-.138-16.578h34.613q17.375-.131 28.219-7.273a31.194 31.194 0 0 0 13.761-19.42h-80.486l6.395-20.955h73.814q-6.673-25.355-40.864-26.428h-39.067l6.534-20.955H249.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 132891",
    d: "M181.553 363.106C81.445 363.106 0 281.662 0 181.554S81.445 0 181.553 0s181.554 81.444 181.554 181.554-81.445 181.552-181.554 181.552m0-341.106C93.575 22 22 93.575 22 181.554s71.575 159.552 159.553 159.552 159.554-71.575 159.554-159.552S269.532 22 181.553 22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/Rupee.7a4ab39dc61cfe292917be0a2cc29630.svg";
export { ForwardRef as ReactComponent };